import state from "lit";
import { state } from "lit/decorators.js";

const LAYOUTS_SPACING = {
    "layouts": {
        "ge-layout-form": {
            "max-width": "1440px"
        }
    }
};

export default LAYOUTS_SPACING;

function applyLayoutSpacing(element, layoutKey, cssVarPrefix, componentName) {
    const values = LAYOUTS_SPACING.layouts[layoutKey] || null;
    if (values && !("max-width" in values)) {
        console.warn(`${componentName}: layout "${layoutKey}" ne définit pas de max-width, valeur par défaut appliquée.`);
    }
    const maxWidth = values?.["max-width"] ?? "100%";
    element.style.setProperty(`${cssVarPrefix}max-width`, maxWidth);

    return !!values;
}

export const LayoutAwareMixin = (superClass) => class extends superClass {
    static properties = {
        ...superClass.properties,
        layoutKey: { type: String },
    };

    @state() _hasLayout = false;

    constructor() {
        super();
        this.layoutKey = null;
    }

    connectedCallback() {
        super.connectedCallback()
        for (const prop of ["layoutKey", '_hasLayout']) {
            if (Object.prototype.hasOwnProperty.call(this, prop)) {
                const val = this[prop];
                delete this[prop];
                this[prop] = val;
            }
        }
    }

    willUpdate(changed) {
        super.willUpdate(changed);
        if (changed.has("layoutKey")) {
            const prefix = `--${this.tagName.toLowerCase().replace('ge-', '')}-`;
            this._hasLayout = applyLayoutSpacing(this, this.layoutKey, prefix);
        }

    }
    getMaxWidthClasses(baseClass) {
        return {
            [baseClass]: true,
            "maxwidth-full": this._isFullWidth && !this._hasLayout,
            "maxwidth-formulaire": !this._isFullWidth && !this._hasLayout,
            "maxwidth-from-layout": this._hasLayout
        };
    }
}